<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M9.83105 16.75V12.25M9.83105 12.25L8.33105 10.75M9.83105 12.25L12.0811 10M15.8311 9.25C15.8311 12.5637 13.1448 15.25 9.83105 15.25C6.51734 15.25 3.83105 12.5637 3.83105 9.25C3.83105 5.93629 6.51734 3.25 9.83105 3.25C13.1448 3.25 15.8311 5.93629 15.8311 9.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'EvergreenIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>